import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/** The external tests (Solutest) URL built server-side with the student's full DNI + phone. */
export function useStudentTestsUrl(enabled = true) {
    return useQuery({
        queryKey: ['student-tests-url'],
        queryFn: () => apiClient('/students/me/tests-url'),
        enabled,
        staleTime: 1000 * 60 * 5,
    });
}
//# sourceMappingURL=useStudentTestsUrl.js.map